import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { AccountingNotFound } from '@/features/accounting/accounting-not-found'
import { loadAccountingNamespaces } from '@/lib/i18n-namespaces'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the accounting module, mirroring `routes/_authenticated/hr`.
 *
 * The grant guard is presentation only. The API enforces each accounting
 * permission on every endpoint and the module gate refuses the whole
 * `/api/accounting` prefix for a group whose plan does not include Accounting,
 * so a stale grant still 403s server-side; this only keeps a user without the
 * grant out of a screen they cannot use.
 */
export const Route = createFileRoute('/_authenticated/accounting')({
  beforeLoad: async ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/' })
    }

    await loadAccountingNamespaces()
  },
  component: () => <Outlet />,
  notFoundComponent: AccountingNotFound,
})
